// extracted by mini-css-extract-plugin
var _1 = "EmailAttachedTagParticipants-moduleparticipants__uLpTK";
export { _1 as "participants" }
